<template>
  <div :id="scrollPosition > 0 ? 'scrollPositImport' : 'beforeScrollPosit'"
       v-b-tooltip.hover
       :class="scrollPosition === 0 ? 'boxImportar' : 'boxImportar fixBox'">
    <div class="row col-12 pr-0 ml-0">
      <!-- <div class="col-sm-3 col-12 pl-2"
           :class="errors.has('dataAverbAll') ? 'mt-0' : 'mt-2'">
        <label for="dataAverbAll"
               class="small mb-0 labelAverb">
          Data para todas as averbações
        </label>

        <input id="dataAverbAll"
               v-model="dataAverbacaoAll"
               v-mask="'##/##/####'"
               v-validate="`date_format:dd/MM/yyyy|date_between:01/01/1500,${limitDate}|max_date:${new Date()}`"
               class="form-control form-control-sm"
               :class="{ 'is-invalid': errors.has('dataAverbAll') }"
               :disabled="[6,7,8,9,10].indexOf(perfil) != -1 && isento ? false : true"
               maxlength="10"
               name="dataAverbAll"
               placeholder="00/00/0000"
               type="text"
               @change="changeDataAverbacaoAll()">

        <small v-if="errors.has('dataAverbAll')"
               class="invalid-feedback ml-0 changePostIconSvg">
          {{ errors.first('dataAverbAll') }}
        </small>
      </div> -->

      <!-- <div :class="!errors.has('dataAverbAll') ? 'col-sm-1 col-12 pl-0 pt-1 iconSVG tooltipHelp' : 'col-sm-1 col-12 pl-0 iconSVG tooltipHelp'"
           data-tooltip="Insira uma data para todas as averbações">
        <icon-svg icon="helpCircle"
                  class="icon--sm"
                  style="fill: #074f7f !important;" />
      </div> -->

      <div class="col-sm-12 col-12 d-flex justify-content-sm-between align-items-center">
        <!-- <button v-if="!uploadComplete"
                class="btn btn-sm-1 btn-outline-danger btn_default mb-3"
                type="button"
                @click="removeFiles">
          Remover arquivos selecionados
        </button> -->
        <b-button variant="secondary"
                  class="btn_default btn_voltar mb-3 mr-2 pl-5 pr-5"
                  @click="() => this.$router.push('/importar-imagens-em-lote')">
          Voltar
        </b-button>
        <b-button v-if="!uploadComplete"
                  class="btn_default mb-3 mr-2"
                  :disabled="stateFiles"
                  @click="onClickUpload">
          Importar arquivos
        </b-button>
      </div>
    </div>
  </div>
</template>

<script>
  import moment from 'moment'
  import { mapGetters } from 'vuex'

  export default {
    name: 'BoxImportarLote',
    props: {
      perfil: {
        type: Number,
        default: 1
      },
      uploadComplete: {
        type: Boolean,
        default: false
      },
      isento: {
        type: Boolean,
        default: false
      },
      origem: {
        type: String,
        default: null
      },
      propSelectedFiles: {
        type: Array,
        default: null
      }
    },
    data () {
      return {
        scrollPosition: 0,
        dataAverbacaoAll: null,
        limitDate: moment(new Date()).add(1, 'day').format('DD/MM/YYYY'),
      }
    },
    computed: {
      ...mapGetters({
        scroll: 'window/getScroll',
        window: 'window/getWindow'
      }),
      stateFiles () {
        let total = 0
        this.propSelectedFiles.forEach(item => {
          if (item.file) {
            total += 1
          }
        })
        return this.propSelectedFiles.length == total ? false : true
      }
    },
    created () {
      let isInit = true

      // Criamos um evento para calcular a posição do box de acordo com o scroll
      window.addEventListener('scroll', () => {
        const scrollable = document.documentElement.scrollHeight - window.innerHeight
        const scrolled = window.scrollY

        isInit = isInit ? this.init(scrollable, scrolled) : this.afterInit(scrollable, scrolled)

        isInit = false
      })
    },
    mounted () {
      window.scrollTo(0, 1)

      if (window.scrollY === 0) {
        this.scrollPosition = Math.round(window.innerHeight * 0.21)
        
        if (this.scrollPosition < 200) {
          this.scrollPosition = 180
        }
        
        const beforeScrollPosit = document.getElementById('beforeScrollPosit')
        
        if (beforeScrollPosit) {
          beforeScrollPosit.setAttribute('style', `--position: ${this.scrollPosition}px`)
        }
      }
    },
    methods: {
      init (scrollable, scrolled) {
        const resultScroll = scrollable - scrolled

        if (this.origem === 'LIVRO') {
          this.scrollPosition = 
            resultScroll < 60 ? 130 :
            resultScroll < 90 ? 105 :
            resultScroll < 100 ? 90 :
            resultScroll < 130 ? 65 :
            resultScroll < 140 ? 45 : 
            resultScroll < 170 ? 15 : 0
        } else {
          this.scrollPosition = 
            resultScroll < 150 ? 55 :
            resultScroll < 170 ? 25 : 0
        }

        const beforeScrollPosit = document.getElementById('beforeScrollPosit')
        
        if (beforeScrollPosit) {
          beforeScrollPosit.setAttribute('style', `--position: ${this.scrollPosition}px`)
        }
      },
      afterInit (scrollable, scrolled) {
        this.scrollPosition = (scrollable - scrolled) <= 180 ? 180 - (scrollable - scrolled) : 0

        const scrollPositImpt = document.getElementById('scrollPositImport')

        if (scrollPositImpt) {
          scrollPositImpt.setAttribute('style', `--position: ${this.scrollPosition}px`)
        }
      },
      changeDataAverbacaoAll () {
        this.$validator.validateAll().then(result => {
          if (result) {
            this.$emit('changeDataAverbacaoAll', this.dataAverbacaoAll)
          }
        })
      },
      removeFiles () {
        this.$emit('removeFiles')
      },
      onClickUpload () {
        this.$emit('onClickUpload')
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import '@/scss/_utilities/_exports';

  .boxImportar {
    position: fixed;
    bottom: 0vh;
    width: pxToRem(1160);
    height: pxToRem(80);
    background-color: white;
    border-style: solid;
    border-color: $color-gray;
    border-width: 1px;
    cursor: auto;
    z-index: 1;

    @media(min-width: pxToRem(790)) {      
      @include calc(width, pxToRem(725), null);
      @include calc(right, '(100vw - #{pxToRem(730)}) / 2', null);
    }
    
    @media(min-width: pxToRem(1024)) {
      @include calc(width, pxToRem(1024), null);
      @include calc(right, '(100vw - #{pxToRem(1028)}) / 2', null);
    }

    @media(min-width: pxToRem(1160)) {
      @include calc(width, pxToRem(1160), null);
      @include calc(right, '(100vw - #{pxToRem(1165)}) / 2', null);
    }
  }

  .fixBox {
    bottom: var(--position);
  }

  .labelAverb {
    color: $color-gray;
    font-weight: bold;
  }

  .iconSVG {
    margin-top: 1.8rem !important;
  }

  .tooltipHelp::before,
  .tooltipHelp::after {
    --scale: 0;
    --tooltip-color: #F9F9F9;
    --tooltip-color-border: rgba(0,0,0,.3);
    position: absolute;
    z-index: 1;
    content: '';
    bottom: -1rem;
    transition: 35ms;
    transform-origin: bottom center;
    transform: translateX(19%) translateY(-30%) scale(var(--scale));
  }

  .tooltipHelp::before {
    content: attr(data-tooltip);
    padding: .5rem;
    width: 15rem;
    color: black;
    border-radius: .7rem;
    word-wrap: break-word;
    background: var(--tooltip-color);
    box-shadow: inset 0 0 0.2em var(--tooltip-color-border);
    -webkit-filter: drop-shadow(2px 2px 2px var(--tooltip-color-border));
    filter: drop-shadow(2px 2px 2px var(--tooltip-color-border));
  }

  .tooltipHelp:hover::before,
  .tooltipHelp:hover::after {
    --scale: 1;
  }

  .tooltipHelp:after {
    content: '';
    position: absolute;
    width: 0;
    height: 0;
    box-shadow: 0px 10px 20px 10;
    border-top: 10px solid transparent;
    border-right: 20px solid var(--tooltip-color);
    border-bottom: 10px solid transparent;
    transform: translateX(20%) translateY(-200%) scale(var(--scale));
    -webkit-filter: drop-shadow(0px 2px 0px var(--tooltip-color-border));
    filter: drop-shadow(0px 1px 0px var(--tooltip-color-border));
  }

  .btn_default {
    margin-top: 1.3rem;
    margin-left: 1rem;
  }
  .btn_voltar {
    background-color: #C6C6C6;
    border: solid 1px #C6C6C6;
    color: black;
  }
</style>
